import { render, staticRenderFns } from "./partyBuildingDetail.vue?vue&type=template&id=dd8cb6a6&scoped=true"
import script from "./partyBuildingDetail.vue?vue&type=script&lang=js"
export * from "./partyBuildingDetail.vue?vue&type=script&lang=js"
import style0 from "./partyBuildingDetail.vue?vue&type=style&index=0&id=dd8cb6a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../usr/local/node_16.9.1/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8cb6a6",
  null
  
)

export default component.exports